import { render, staticRenderFns } from "./Sedes.vue?vue&type=template&id=7255fcc6&scoped=true"
import script from "./Sedes.vue?vue&type=script&lang=js"
export * from "./Sedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7255fcc6",
  null
  
)

export default component.exports